"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RightsholderAccountCard = void 0;
const react_1 = __importDefault(require("react"));
const AccountCard_1 = __importDefault(require("@Components/Cards/AccountCard"));
const navigation_1 = __importDefault(require("@App/navigation"));
const rightsholder_statuses_1 = require("@Const/rightsholder-statuses");
const common_1 = require("@Const/common");
const RightsholderAccountCard = (props) => {
    const { rightsholderData, openPopup, viewDetails = true } = props;
    const idForLink = 'id' in rightsholderData ? rightsholderData.id : rightsholderData.ipId;
    const isValidationStatusWrong = !rightsholderData.validationStatus ||
        rightsholderData.validationStatus === rightsholder_statuses_1.RIGHTSHOLDER_VALIDATION_STATUSES.HFA_COPIED.name;
    return (react_1.default.createElement(AccountCard_1.default, { name: rightsholderData.name, totalWorks: rightsholderData.totalWorks, isValidationStatusWrong: isValidationStatusWrong, teamMembers: rightsholderData.teamMembers, validationStatus: rightsholderData.validationStatus, updateDate: 'updateDate' in rightsholderData ? rightsholderData.updateDate : undefined, openPopup: openPopup, viewDetails: viewDetails, link: navigation_1.default.rightholder.summary(idForLink), icon: common_1.ICONS.account, blueImageFilter: true }));
};
exports.RightsholderAccountCard = RightsholderAccountCard;
exports.default = exports.RightsholderAccountCard;
